// tslint:disable:trailing-comma

import { NeoNamespace } from '../common-enum';
import { DebugLevel } from '../util/debug';

export interface NeoConfig {
  // 是否开启 mock（目前是获取全量参数桥 mock）
  mock?: boolean;
  // debug 级别
  debugLevel?: DebugLevel;
  // debug 模块命名空间
  debugNamespace?: NeoNamespace[];
  // 参数校验函数
  paramsValidator?: (params: any) => boolean;
  // 预请求数据 key 数组
  prefetchKeyList: string[];
  // 统计基础参数
  statBasicParams: any;
  // 映射初始化参数至统计基础参数
  mapStatBasicParams?: (params: any) => any;
}

export const defaultNeoConfig: NeoConfig = {
  mock: false,
  debugLevel: DebugLevel.Info,
  debugNamespace: [],
  prefetchKeyList: [],
  statBasicParams: {},
};

export default defaultNeoConfig;
